import { Env } from '@Constants/BuildInfo';

const FORMATS = {
  RXNV3: 'rxn:V3',
  MOL: 'mol',
  MRV: 'mrv',
};

export const MARVIN_TEXTS = {
  notAllowedReactionFilter: {
    type: 'error',
    confirmText: 'Ok',
    title: 'Warning',
    text: 'Please note: Reactions are not supported by Substructure Filter. Please only draw a single structure query for filtering.',
  },
  notAllowedReactionLicense: {
    type: 'info',
    confirmText: 'Ok',
    text:
      'Reaction searches are not supported on a Reaxys Medicinal Chemistry only licence. ' +
      'If you require further assistance please contact your administrator or the Reaxys Support team.',
  },
};

export const MarvinConfig = {
  FORMATS,
  intermediateImageExporterFormat: FORMATS.MRV, // MRV or MOL
  defaultImageExporterOptions: {
    // format: undefined, // === exportFormat
    imageType: 'png',
    // https://marvinjs-demo.chemaxon.com/latest/jsdoc.html
    carbonLabelVisible: false,
    chiralFlagVisible: true,
    valenceErrorVisible: true,
    lonePairsVisible: false,
    lonepaircalculationenabled: false,
    atomIndicesVisible: false,
    atomMapsVisible: true,
    cpkColoring: true,
    displayMode: 'WIREFRAME',
    implicitHydrogen: 'TERMINAL_AND_HETERO',
    backgroundColor: null,
    zoomMode: 'fit',
    width: 663,
    height: 510,
  },
  GUI_SCRIPT: `${Env.StructureEditorsHostUrl}/cdn/structure-editor/gui/gui.nocache.js`,
  exportFormat: FORMATS.RXNV3,
  defaultBoundPosition: 3,
  imageSizeByCountOfBounds: {
    /* Due to Juergen's comment in bug RXFE-3438
        default: 490x50px
        1-10 bonds: 200x200px
        11-20 bonds: 300x200px
        21-50 bonds: 400x300px
        >50 bonds: 490x300 px
      */
    '1-10': { width: 200, height: 200 },
    '11-20': { width: 300, height: 200 },
    '21-50': { width: 400, height: 300 },
    '51-...': { width: 490, height: 300 },
    defaults: { width: 490, height: 50 },
  },
  templateUrl: 'templates/default_templates_with_extra.json',
};

export function getDefaultServicesPrefix() {
  return Env.ChemaxonUrlPrefix;
}

/**
 * @ngdoc function
 * @name getDefaultServices
 * @description define the default location of web services
 */
export function getDefaultServices() {
  const base = getDefaultServicesPrefix();
  return {
    clean2dws: `${base}/rest-v1/util/convert/clean`,
    clean3dws: `${base}/rest-v1/util/convert/clean`,
    molconvertws: `${base}/rest-v1/util/calculate/molExport`,
    stereoinfows: `${base}/rest-v1/util/calculate/cipStereoInfo`,
    reactionconvertws: `${base}/rest-v1/util/calculate/reactionExport`,
    hydrogenizews: `${base}/rest-v1/util/convert/hydrogenizer`,
    automapperws: `${base}/rest-v1/util/convert/reactionConverter`,
    aromatizews: `${base}/rest-v1/util/calculate/molExport`,
  };
}
